var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
		{
			'builder-element': !_vm.onPreview,
			'hide-desktop': _vm.node.options.visible_desktop,
			'hide-mobile': _vm.node.options.visible_mobile,
		},
		_vm.node.class ],style:(_vm.getMainWrapperStyle(_vm.node)),attrs:{"id":_vm.node.id,"data-key":_vm.node.key,"data-elIcon":_vm.node.icon,"data-elName":_vm.node.name,"data-type":_vm.node.type},on:{"click":function($event){return _vm.onNodeClick(_vm.node)}}},[(!_vm.onPreview)?_c('NodeAction',{attrs:{"node":_vm.node,"component":"element"}}):_vm._e(),_c('div',{staticClass:"divider-wrapper",style:(_vm.getWidthStyle(_vm.node))},[_c('div',{class:_vm.node.class,style:(_vm.getStyle(_vm.node))})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }